import { render, staticRenderFns } from "./message-confirm.vue?vue&type=template&id=a6cda5a6"
import script from "./message-confirm.vue?vue&type=script&lang=js"
export * from "./message-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports